export const TrackerData = [
    {id: 0, steps: "Order Confirmed", remarks: "Order Confirmed",  img: "", date: "28-12-2022"},
    {id: 1, steps: "R M Processed", remarks: "Pending",  img: "", date: "28-12-2022"},
    {id: 2, steps: "Printing", remarks: "Pending",  img: "", date: "28-12-2022" },
    {id: 3, steps: "Finishing", remarks: "Pending",  img: "", date: "28-12-2022" },
    {id: 4, steps: "Final Stage", remarks: "Pending",  img: "", date: "28-12-2022" },
    {id: 5, steps: "Dispatched", remarks: "Pending",  img: "", date: "28-12-2022" },
    {id: 6, steps: "In Transit", remarks: "Pending",  img: "", date: "28-12-2022" },
    {id: 7, steps: "Delivered", remarks: "Pending",  img: "", date: "28-12-2022" },
  ]